// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"b8f47918","129":"56c175b3","330":"b09b0de9","331":"19ca6b0a","450":"64c1325f","453":"09dbfeaa","486":"1a499cab","674":"d6bd9a58","704":"a86d1f06","832":"120aa7c5"}[chunkId] + ".chunk.js";
};